<template>
  <div class="enroll-interview-setting"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="body">
      <div class="left-container">
        <div class="title">
          <span>面试安排查看时间设置</span>
        </div>
        <div>
          <el-date-picker
            v-model="interviewDate"
            v-show="isEdit"
            size="mini"
            :disabled="!isEdit"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format = "yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          <span v-show="!isEdit">
            <template v-if="interviewDate && interviewDate.length > 0">
              {{ interviewDate[0] }} 至 {{ interviewDate[1] }}
            </template>
            <template v-else>
              暂未设置
            </template>
          </span>
        </div>
      </div>
      <div class="right-container">
        <div class="title">
          <span>面试考试须知</span>
          <el-button v-show="isEdit" type="primary" size="mini" @click="submitData" :loading="committing">确认</el-button>
          <el-button v-show="!isEdit" type="primary" size="mini" @click="isEdit = true">编辑</el-button>
        </div>
        <div>
          <AmEditor v-show="isEdit" v-model="interviewNotice" :editorHeight="100" :disabled="!isEdit"></AmEditor>
          <div v-show="!isEdit" class="notice" v-html="interviewNotice"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AmEditor from '../../../../../../../elements/editor/AmEditor'
export default {
  name: 'EnrollInterviewSetting',
  components: {AmEditor},
  props: {
    site: String,
    studentType: String
  },
  data () {
    return {
      interviewDate: [],
      interviewNotice: '',
      loading: false,
      committing: false,
      isEdit: false
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/interview/group/queryInterviewConfig',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          site: this.site,
          studentType: this.studentType
        }), {arrayFormat: 'repeat'})
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.interviewDate = response.data.interviewDate || []
              this.interviewNotice = response.data.interviewNotice || ''
              break
            }
            default: {
              this.interviewDate = []
              this.interviewNotice = ''
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    submitData () {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/enrolling/interview/group/setInterviewConfig',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          site: this.site,
          studentType: this.studentType,
          interviewDate: this.interviewDate,
          interviewNotice: this.interviewNotice
        }), {arrayFormat: 'repeat'})
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.isEdit = false
              this.$message.success(response.data['message'])
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  mounted () {
    this.loadData()
  },
  activated () {
    this.loadData()
  },
  watch: {
    site (val) {
      this.loadData()
    }
  }
}
</script>

<style lang="scss">
.enroll-interview-setting {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ebeef5;
  padding: 0 15px 10px;

  & > .body {
    display: flex;
    & > .left-container, .right-container {
      flex: 1;
      display: flex;
      flex-direction: column;

      .title {
        height: 46px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > span {
          font-size: 15px;
          line-height: 46px;
        }
      }
      .notice {
        padding: 5px;
        height: 140px;
        overflow: auto;
        border: 1px solid #ebeef5;
        border-radius: 5px;
      }
    }
  }
}
</style>
